import React from 'react';
import { Typography } from 'antd';
import { NETWORKS, NETWORK_ORDER, SupportedNetwork } from '../constants/networks';

const { Text } = Typography;

interface NetworkSelectorProps {
  activeNetwork: SupportedNetwork;
  onSelectNetwork: (network: SupportedNetwork) => void;
  connectedNetworks?: Partial<Record<SupportedNetwork, boolean>>;
  /** Ряд круглых иконок как на главной KredaFi. Остальные экраны — прежний вид. */
  variant?: "default" | "platforms";
}

/** Переключатель сетей [ TON | Polygon | Solana | TRON ] — только вне Telegram. */
export const NetworkSelector: React.FC<NetworkSelectorProps> = ({
  activeNetwork,
  onSelectNetwork,
  connectedNetworks = {},
  variant = "default",
}) => {
  if (variant === "platforms") {
    return (
      <div className="kf-platforms" data-testid="network-selector">
        {NETWORK_ORDER.map((netId) => {
          const meta = NETWORKS[netId];
          const isSelected = activeNetwork === netId;
          const isConnected = !!connectedNetworks[netId];
          const label = meta.name === "BNB Chain" ? "BNB" : meta.name;
          return (
            <button
              key={netId}
              type="button"
              data-testid={`network-tab-${netId}`}
              aria-pressed={isSelected}
              className={isSelected ? "on" : ""}
              onClick={() => onSelectNetwork(netId)}
            >
              <span className="kf-plat-ico">
                <img
                  src={meta.icon}
                  alt={meta.name}
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = "none";
                  }}
                />
                {isConnected && <span className="kf-plat-dot" />}
              </span>
              <span className="kf-plat-name">{label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div
      data-testid="network-selector"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${NETWORK_ORDER.length}, minmax(0, 1fr))`,
        gap: '4px',
        padding: '4px',
        background: '#f1f5f9',
        borderRadius: '14px',
        marginBottom: '12px',
      }}
    >
      {NETWORK_ORDER.map((netId) => {
        const meta = NETWORKS[netId];
        const isSelected = activeNetwork === netId;
        const isConnected = !!connectedNetworks[netId];

        return (
          <button
            key={netId}
            type="button"
            data-testid={`network-tab-${netId}`}
            aria-pressed={isSelected}
            onClick={() => onSelectNetwork(netId)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 2px',
              minWidth: 0,
              borderRadius: '10px',
              border: isSelected ? '1px solid #cbd5e1' : '1px solid transparent',
              background: isSelected ? '#ffffff' : 'transparent',
              boxShadow: isSelected ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
              cursor: 'pointer',
              transition: 'all 0.18s ease',
              position: 'relative',
            }}
          >
            <div style={{ position: 'relative', display: 'inline-flex' }}>
              <img
                src={meta.icon}
                alt={meta.name}
                style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'contain' }}
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
              {isConnected && (
                <span
                  style={{
                    position: 'absolute',
                    top: -2,
                    right: -2,
                    width: 7,
                    height: 7,
                    borderRadius: '50%',
                    background: '#52c41a',
                    border: '1.5px solid #fff',
                  }}
                />
              )}
            </div>

            <Text
              strong={isSelected}
              style={{
                fontSize: '10.5px',
                marginTop: '4px',
                color: isSelected ? '#0f172a' : '#64748b',
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              {meta.name === 'BNB Chain' ? 'BNB' : meta.name}
            </Text>
          </button>
        );
      })}
    </div>
  );
};

export default NetworkSelector;
